import { render } from "./Guest.vue?vue&type=template&id=2d6cb4de"
import script from "./Guest.vue?vue&type=script&lang=js"
export * from "./Guest.vue?vue&type=script&lang=js"

import exportComponent from "/home/appfloretcollegein/app.floretcollege.in/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__